import Vue from 'vue';
import App from './App.vue';
import router from './router';
import keycloak from './keycloak';
import './plugins/elements';
import authenticationMixin from "./mixins/authentication";

Vue.config.productionTip = false;
Vue.mixin(authenticationMixin);

keycloak.init({ onLoad: 'login-required' }).then((authenticated) => {
  new Vue({
    router,
    render: (h) => h(App),
    data: {
      authenticated,
      user: authenticated ? keycloak.tokenParsed : null,
    },
  }).$mount('#app');
});
